import React from 'react';
import { Link } from 'react-router-dom';

const Products: React.FC = () => {
  return (
    <div className="pt-16 min-h-screen bg-cream">
      {/* Header */}
      <section className="py-20 bg-navy text-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <p className="text-sm font-semibold tracking-widest text-teal uppercase mb-4">Products</p>
          <h1 className="text-4xl md:text-5xl font-serif mb-6">
            Built for institutions
          </h1>
          <p className="text-lg text-white/70 leading-relaxed">
            Intelligence platforms designed for the teams financing the energy transition.
          </p>
        </div>
      </section>

      {/* Product Cards */}
      <section className="py-20 bg-cream">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8">

            {/* GIRMP — featured */}
            <Link
              to="/products/girmp"
              className="group md:col-span-2 bg-gradient-to-br from-[#0a1628] to-[#0f2035] text-white p-10 rounded-2xl border border-white/10 hover:border-teal/40 transition-all duration-300 hover:shadow-2xl hover:shadow-teal/10"
            >
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
                <div className="max-w-xl">
                  <span className="inline-block text-xs font-semibold tracking-widest text-teal uppercase bg-teal/10 px-3 py-1 rounded-full mb-4">
                    Live
                  </span>
                  <h2 className="text-3xl md:text-4xl font-serif mb-4">GIRMP</h2>
                  <p className="text-white/60 text-sm mb-2">Green Infrastructure Risk Management Platform</p>
                  <p className="text-white/80 leading-relaxed">
                    Six intelligence modules in one unified workspace — policy tracking, financial metrics, 
                    credit risk, ESG compliance, investment trends, and an integrated dashboard. 
                    Purpose-built for institutional workflows.
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <span className="inline-flex items-center text-teal font-medium group-hover:translate-x-1 transition-transform duration-200">
                    Explore GIRMP
                    <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </span>
                </div>
              </div>
            </Link>

            {/* Future Product Placeholder 1 */}
            <div className="bg-white p-8 rounded-2xl border border-gray-100 opacity-60">
              <span className="inline-block text-xs font-semibold tracking-widest text-gray-400 uppercase bg-gray-50 px-3 py-1 rounded-full mb-4">
                Coming Soon
              </span>
              <h3 className="text-xl font-serif text-navy mb-2">More to come</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We're building additional intelligence tools for the sustainable finance ecosystem. Stay tuned.
              </p>
            </div>

            {/* Future Product Placeholder 2 */}
            <div className="bg-white p-8 rounded-2xl border border-gray-100 opacity-60">
              <span className="inline-block text-xs font-semibold tracking-widest text-gray-400 uppercase bg-gray-50 px-3 py-1 rounded-full mb-4">
                Coming Soon
              </span>
              <h3 className="text-xl font-serif text-navy mb-2">Stay informed</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                <Link to="/contact" className="text-teal hover:underline">Get in touch</Link> to be notified when new products launch.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
